(function(){
  const product_details = document.querySelector(".product__grid-column--details")
  if(product_details){
    // Track processed widgets using WeakMap to avoid memory leaks
    const processedWidgets = new WeakMap();
    
    // Create a single observer instance
    const widgetObserver = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeName === 'DIV' && node.classList.contains("bndlr-volume")) {
            initializeWidget(node);
          }
          if (node.nodeName === 'DIV' && node.classList.contains('sealsubs-target-element')) {
            initializeSealsubsWidget(node);
          }
        });
      });
    });

    const inputObserver = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            updateProductPrice();
        }
      });
    });

    
    function initializeWidget(widget) {
      if (processedWidgets.has(widget)) return;
      processedWidgets.set(widget, true);
    

      const bndlr_volume_discounts = widget.querySelectorAll(".bndlr-volume-discount")
      if(bndlr_volume_discounts.length > 0){
        bndlr_volume_discounts[0].classList.add("active")
      }
      bndlr_volume_discounts.forEach(item => {
        item.addEventListener("click", () => {
          bndlr_volume_discounts.forEach(discount=>discount.classList.remove("active"))
          item.classList.add("active");
          updateProductPrice();
        });
      })

      // update atc button
     const buy_buttons_button = product_details.querySelector(".buy-buttons .buy-buttons__form .button-action");

      if(buy_buttons_button){
        buy_buttons_button.addEventListener("click", (event) => {
          const discount_button = product_details.querySelector(".bndlr-volume-discount.active .bndlr-volume-saving-text");
          if(discount_button){
            event.preventDefault();
            discount_button.click();
          }
        });

        

        const targetNode = document.querySelector('.header__cart-count');
        const observerCart = new MutationObserver((mutationsList, observer) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'attributes') {
              Core.Components.getComponent("cart-drawer").open(buy_buttons_button, true)
            }
          }
        });
        if (targetNode) {
          observerCart.observe(targetNode, { attributes: true,attributeFilter: ['data-cart-count']  });
        }
      }
      
    }
    function initializeSealsubsWidget(widget){
      if (processedWidgets.has(widget)) return;
      processedWidgets.set(widget, true);
      const input = widget.querySelector("input[data-sls-selling_plan]");
      if(input){
        inputObserver.observe(input, { attributes: true, attributeFilter: ['value'] });
      }
    }

    function updateProductPrice(){
      const select_discounts = product_details.querySelector(".bndlr-volume-discount.active");
      const prices_container = product_details.querySelectorAll(".sls-option-container");
      if(select_discounts){
        if(document.querySelector(".bundler-volume-target-element__info")){
          document.querySelector(".bundler-volume-target-element__info").remove()
        }
        let discount_text = ""
        if(select_discounts.classList.contains("bndlr-has-savings-text")){
          discount_text = product_details.querySelector(".bndlr-volume-discount.active .bndlr-volume-saving-text").innerText;
          // select_discounts.closest(".bundler-volume-target-element").insertAdjacentHTML("beforebegin", "<div class='bundler-volume-target-element__info'>Bundle discount will be applied at checkout("+discount_text+")</div>");
        }
        prices_container.forEach(price_container => {
          const price = price_container.querySelector(".sls-price .money");
          if(!price_container.dataset.originalPirce){
            price_container.dataset.originalPirce = price.innerText;
            price_container.dataset.quantity = select_discounts.dataset.quantity;
          }
          price.innerText = price_container.dataset.originalPirce;
          const originalPrice = price.innerText;
          const numericValue = parseFloat(originalPrice.replace(/[^\d.]/g, ''));
          let doubledValue = (numericValue * select_discounts.dataset.quantity).toFixed(2);
          if(discount_text){
            if(discount_text.indexOf("%") > -1 ){
              doubledValue = doubledValue * (1 - parseFloat(discount_text.replace(/[^\d.]/g, ''))/100)
            }else{
              doubledValue = doubledValue - parseFloat(discount_text.replace(/[^\d.]/g, ''))
            }
          }
          const formattedPrice = originalPrice.replace(/\d+(\.\d+)?/, parseFloat(doubledValue).toFixed(2));
          price.textContent = formattedPrice;
        })
        
        // product price
        const orignialPrice = product_details.querySelector(".sls-option-container.sls-active");
        const product_prices = product_details.querySelectorAll(".product-block__price .money");
        product_prices.forEach(price => {
          if(!price.dataset.originalPirce){
            price.dataset.originalPirce = price.innerText;
            price.dataset.quantity = select_discounts.dataset.quantity;
          }
          if(orignialPrice){
             price.dataset.originalPirce = orignialPrice.dataset.originalPirce?orignialPrice.dataset.originalPirce: orignialPrice.querySelector(".sls-price .money").innerText;
          }
          price.innerText = price.dataset.originalPirce
          const originalPrice = price.innerText;
          const numericValue = parseFloat(originalPrice.replace(/[^\d.]/g, ''));
          let doubledValue = (numericValue * select_discounts.dataset.quantity).toFixed(2);
          if(discount_text){
            if(discount_text.indexOf("%") > -1 ){
              doubledValue = doubledValue * (1 - parseFloat(discount_text.replace(/[^\d.]/g, ''))/100)
            }else{
              doubledValue = doubledValue - parseFloat(discount_text.replace(/[^\d.]/g, ''))
            }
          }
          const formattedPrice = originalPrice.replace(/\d+(\.\d+)?/, parseFloat(doubledValue).toFixed(2));
          price.textContent = formattedPrice;
        })
      }
    }
    
    
    widgetObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})()